import { Coordinate } from "@nova/protobuf"
import { calculateBoundingBox } from "@nova/calculate-geospatial"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { CogTileLayer } from "features/map/layers/cog/CogTileLayer"
import { CogTileSource } from "features/map/layers/cog/fetchCogTile"

type PDFRasterTileQuery = {
    orgId: string
    projectId: string
    filename: string
}

const pdfRasterTileSource =
    ({ orgId, projectId, filename }: PDFRasterTileQuery): CogTileSource =>
    ({ x, y, z }, signal) =>
        fetchApiGateway("get /org/:orgId/project/:projectId/pdf-raster/:filename/tile/:z/:x/:y", {
            params: { orgId, projectId, filename, z, x, y },
            headers: { Accept: "image/png" },
            rawResponse: true,
            signal,
            query: "tilesize=512",
        })

export const PDFRasterTileLayer = ({
    id,
    orgId,
    projectId,
    filename,
    corners,
}: PDFRasterTileQuery & { id: string; corners: Coordinate[] }) => {
    const { minlng, minlat, maxlng, maxlat } = calculateBoundingBox(corners).bbox

    return CogTileLayer({
        id: `pdf-raster-tile-layer-${id}`,
        source: pdfRasterTileSource({ orgId, projectId, filename }),
        extent: [minlng, minlat, maxlng, maxlat],
        invalidateOn: { source: [orgId, projectId, filename] },
        tileSize: 512,
        maxRequests: 16,
    })
}
